import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Select } from "@opendate-app/setlist";
import "./classesWizard.css";

function ValidatedSelect({ id, error, announce, ...selectProps }) {
  const fieldRef = useRef(null);

  useEffect(() => {
    const combobox = fieldRef.current.querySelector('[role="combobox"]');
    if (!combobox) return;
    if (error) combobox.setAttribute("aria-invalid", "true");
    else combobox.removeAttribute("aria-invalid");
  }, [error]);

  return (
    <div data-field={id} ref={fieldRef}>
      <Select id={id} aria-labelledby={error ? `${id}-label ${id}-error` : undefined} {...selectProps} />
      <p id={`${id}-error`} className="classes-field-error" role={announce ? "alert" : undefined}>{error}</p>
    </div>
  );
}

ValidatedSelect.propTypes = {
  id: PropTypes.string.isRequired,
  error: PropTypes.node,
  announce: PropTypes.bool,
};

ValidatedSelect.defaultProps = {
  error: null,
  announce: false,
};

export default ValidatedSelect;
